"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _RadioButton = _interopRequireDefault(require("./RadioButton")),
    _radioGroup = _interopRequireDefault(require("../styles/radioGroup"));

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var NON_RADIO_CHILDREN_ERR = "All children of RadioGroup must be of type RadioButton.";

function checkRadioButtonChildren(a) {
  if (Array.isArray(a)) return void a.forEach(function (a) {
    if (a.type !== _RadioButton["default"]) throw new Error(NON_RADIO_CHILDREN_ERR);
  });
  if (!a || a.type !== _RadioButton["default"]) throw new Error(NON_RADIO_CHILDREN_ERR);
}

var RadioGroup = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onSelectRadio = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.props,
            c = b.onlyOneSelected,
            e = b.onChange,
            f = b.children,
            g = b.disabled,
            h = d.state.selectedIndexes;

        if (!g && !(c && h.length && h[0] === a)) {
          var i = Array.isArray(f) ? f[a].props : f.props,
              j = i.value;
          if (c) return e({
            value: j
          }), void d.setState({
            selectedIndexes: [a]
          });

          if (!h.includes(a)) {
            var m = [].concat((0, _toConsumableArray2["default"])(h), [a]);
            return e({
              selected: !0,
              allItemsSelected: !f.length || m.length === f.length,
              value: j
            }), void d.setState({
              selectedIndexes: m
            });
          }

          var k = h.findIndex(function (b) {
            return b === a;
          }),
              l = (0, _toConsumableArray2["default"])(h);
          l.splice(k, 1), e({
            selected: !1,
            allItemsSelected: !1,
            value: j
          }), d.setState({
            selectedIndexes: l
          });
        }
      };
    }), d.addPropsToRadioButton = function (a, b) {
      var c = d.props,
          e = c.disabled,
          f = c.darkMode,
          g = d.state.selectedIndexes;
      return _react["default"].cloneElement(a, {
        selected: g.includes(b),
        onChange: d.onSelectRadio(b),
        disabled: e,
        darkMode: f
      });
    }, d.addPropsToRadioButtons = function () {
      var a = d.props.children;
      return Array.isArray(a) ? a.map(d.addPropsToRadioButton) : d.addPropsToRadioButton(a, 0);
    }, checkRadioButtonChildren(a.children), d.state = {
      selectedIndexes: []
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_radioGroup["default"], "radio-group")
      }, this.addPropsToRadioButtons());
    }
  }]), b;
}(_react.Component);

exports["default"] = RadioGroup;